import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapUserData } from './authClient.formatter';

const authApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const signupWithEmailAndPassword = (data: Auth.SignupWithEmailAndPassword, companySlug?: string) => {
  const payload: Auth.SignupWithEmailAndPasswordRequest = { ...data, companySlug };
  return request({
    authenticate: false,
    options: {
      url: `${authApiBaseUrl}/signup/`,
      method: 'POST',
      data: snakizeObject<Auth.SignupWithEmailAndPasswordApi>(payload),
    },
  });
};

const signupWithSSO = ({ invitationToken, companySlug }: Auth.SignupWithSSORequest = {}) => {
  return request({
    options: {
      url: `${authApiBaseUrl}/signup-with-sso/`,
      method: 'POST',
      data: snakizeObject({
        userInvitationId: invitationToken,
        companySlug,
      }),
    },
  });
};

const getMe = (): Promise<AxiosResponse<Users.User>> => {
  return request({
    options: {
      url: `${authApiBaseUrl}/users/me`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Users.UserApi>) => ({
    ...data,
    data: mapUserData(data.data),
  }));
};

const authenticateUserByToken = (data: Auth.AuthenticateUserByToken): Promise<AxiosResponse<Auth.TokenUserAuthenticationResponse>> => {
  return request({
    authenticate: false,
    options: {
      url: `${authApiBaseUrl}/authenticate-by-token/`,
      method: 'POST',
      data: snakizeObject<Auth.AuthenticateUserByToken>(data),
    },
  });
};

export const authClient = {
  authenticateUserByToken,
  signupWithEmailAndPassword,
  signupWithSSO,
  getMe,
};
